<template>
	<div class="per_right">
		<div class="per_right_1 clearfix">
			<img src="@/images/center_title.png" class="per_right_1back"/>
			<img src="@/images/center_text1.png" class="per_right_1name"/>
		</div>
		<div class="per_right_2">
			<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
				<el-form-item label="头像" prop="head" class="per_title">
					<div class="headbox">
						<img :src='baseurl + userinfo.iconurl' style="width: 80px;height: 80px;" v-if="userinfo.iconurl" />
						<div class="headError" style="width: 80px;height: 80px;" v-if="!userinfo.iconurl">
							暂无头像
						</div>
						<el-upload class="headedit" v-show='editing' action="#" accept=".jpg,.png,.jpeg" :http-request="option => handleFileUpload(option, 'cover')" :show-file-list="false">
							<div style="width: 80px;height: 80px">
								<div v-if="!ruleForm.iconurl"><i class="el-icon-plus"></i></div>
								<img :src='ruleForm.iconurl' style="width: 80px;height: 80px;" v-if="ruleForm.iconurl !=''" />
							</div>
						</el-upload>
					</div>
				</el-form-item>
				<el-form-item label="姓名" prop="name" class="per_title">
					<span v-show='!editing'>{{userinfo.name}}</span>
					<el-input v-model="ruleForm.name" class="per_input" v-show='editing'></el-input>
				</el-form-item>
				<el-form-item label="性别" prop="sex" class="per_title">
					<span v-show='!editing'>{{userinfo.sex == 1?'女':'男'}}</span>
					<el-radio-group v-model="ruleForm.sex" v-show='editing'>
						<el-radio :label="0" class="per_radio">男</el-radio>
						<el-radio :label="1" class="per_radio">女</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="手机号" prop="mobile" class="per_title">
					<span v-show='!editing'>{{userinfo.mobile || '无'}}</span>
					<el-input v-model="ruleForm.mobile" class="per_input" v-show='editing'></el-input>
				</el-form-item>

				<el-form-item class="per_save" v-show='!editing'>
					<div class="feedback_button" @click="editing = true">
						<img src="@/images/zy_button.png" class="feedback_back" />
						<span>编辑</span>
					</div>
				</el-form-item>
				<el-form-item class="per_save" v-show='editing'>
					<div class="feedback_button" @click="submitForm('ruleForm')">
						<img src="@/images/zy_button.png" class="feedback_back" />
						<span>保存</span>
					</div>
					<div class="feedback_button" @click="resetForm()">
						<img src="@/images/zy_button_cancel.png" class="feedback_back" />
						<span>取消</span>
					</div>
				</el-form-item>
			</el-form>
		</div>
	</div>
</template>

<script>
	import { updateUser, getInfo } from '@/api/user.js'
	import { deptList } from '@/api/sysDept.js'
	import { putProgress } from "@/utils/oss.js"
	import { removeToken, removeStorageToken } from '@/utils/auth'
	export default {
		data() {
			var validatorphone = (rule, value, callback) => {
				let reg = /^1[3456789]\d{9}$/;
				if(!reg.test(value)) {
					callback(new Error('请输入正确的手机号码'))
				} else {
					callback()
				}
			};
			return {
				//标签页
				editing: false,
				depts: [],
				tabPosition: 'left',
				userinfo: {},
				props: {
					checkStrictly: true,
					value: 'id',
					label: 'text',
				},
				//表单
				ruleForm: {
					iconurl: '',
					name: '',
					sex: '',
					mobile: '',
					userId: '',
				},
				rules: {
					name: [{
						required: true,
						message: '请输入姓名',
						trigger: 'blur'
					}],
					sex: [{
						required: true,
						message: '请选择性别',
						trigger: 'change'
					}],
					// mobile: [
						// {
					// 		required: true,
					// 		message: '请输入手机号'
					// 	},
					// 	{
					// 		validator: validatorphone,
					// 		trigger: 'blur    ',
					// 		message: '请输入手机号',
					// 	}
					// ],
				}
			};
		},
		created() {
			this.getMyInfo();
			this.getDeptList();
		},
		methods: {
			handleFileUpload(option) {
				var that = this;
				const {
					file
				} = option;
				var userId = this.userinfo.userId
				const suffix = file.name.slice(file.name.lastIndexOf("."));
				const key = `cdzy/iconurl/${userId}/${this.createUUID()}${suffix}`;
				putProgress(key, file, function(progress) {
					that.coverFlag = true;
						that.coverProgress = Math.round(progress * 100) || 0;
				}).then(res => {
					var iconurl = key;
					this.ruleForm.iconurl = iconurl;
					this.userinfo.iconurl = iconurl;
					this.$set(this.ruleForm, 'iconurl', iconurl)
					this.coverFlag = false;
					this.coverProgress = 0;
				});
			},
			getMyInfo() {
				getInfo().then(res => {
					this.userinfo = res.data;
					this.ruleForm = {
						iconurl: res.data.iconurl,
						name: res.data.name,
						sex: res.data.sex,
						mobile: res.data.mobile,
						userId: res.data.userId,
					};
				})
			},
			getDeptList() {
				deptList({}).then(async res => {
					this.depts = res.children
				})
			},
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if(valid) {
						var data = {
							userId: this.ruleForm.userId,
							iconurl: this.ruleForm.iconurl,
							name: this.ruleForm.name,
							sex: this.ruleForm.sex,
							mobile: this.ruleForm.mobile,
						}
						updateUser(data).then(res => {
							if(res.code == 'OK') {
								this.$alert('修改成功，请重新登陆！', '提示', {
									confirmButtonText: '确定',
									type: 'warning'
								}).then(() => {
									removeToken();
									removeStorageToken();
									location.reload()
								}).catch(() => {
									removeToken();
									removeStorageToken();
									location.reload()
								})
							} else {
								this.$message({
									type: "error",
									message: res.msg
								})
							}
						})
					}
				});
			},
			resetForm() {
				this.$refs.ruleForm.resetFields();
				this.$refs.ruleForm.clearValidate()
				this.getMyInfo();
				this.editing = false;
			},
			createUUID() {
				return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, c => {
					let r = (Math.random() * 16) | 0,
						v = c == "x" ? r : (r & 0x3) | 0x8;
					return v.toString(16);
				});
			},
		}
	}
</script>

<style>

</style>